<script setup>
import { useCasinoGamesStore } from "@stores/casino-games";
import { useSettingsStore } from "@stores/settings";
import { useToPlayStore } from "@stores/to-play";

const casinoGamesStore = useCasinoGamesStore();
const settingsStore = useSettingsStore();
const toPlayStore = useToPlayStore();

const settings = settingsStore.settings;
</script>

<template>
  <div>
    <div
      class="grid grid-cols-2 gap-4 pt-3 xs:grid-cols-3 sm:grid-cols-4 sm:gap-5 sm:gap-y-10 md:grid-cols-5"
    >
      <!-- Listagem de cards dos jogos -->
      <BaseGame
        v-for="item in casinoGamesStore?.games.filter(
          (game) => game?.id !== toPlayStore.state.activeGame?.id,
        )"
        :key="item.id"
        :data="item"
      />

      <!-- Fim da listagem dos cards dos jogos -->
      <PageLoadersCassinoLoader v-if="casinoGamesStore.state.isLoading" />
    </div>
    <div
      v-if="casinoGamesStore.games.length === 0"
      class="mt-5 flex items-center justify-center rounded-sm bg-black/30 p-6 text-center"
    >
      <div
        v-if="
          casinoGamesStore.state.searchString !== '' ||
          casinoGamesStore.state.searchByProvider.length > 0
        "
      >
        <p>Não há nenhum jogo disponível com os filtros selecionados.</p>
        <p
          class="cursor-pointer text-sm opacity-50 hover:opacity-100"
          @click="
            casinoGamesStore.resetFilters();
            casinoGamesStore.get();
          "
        >
          Que tal visualizar todos os jogos?
        </p>
      </div>
      <div v-else>Não há nenhum jogo disponível.</div>
    </div>

    <!-- Paginação dos jogos de cassino -->
<!--    <CasinoPagination />-->
  </div>
</template>
